export default __webpack_public_path__ + "static/media/top.a20d825e.png";